import React from 'react';
import { Box } from '@mui/material';

export const JuncerFinanceIcon = () => (
  <Box
    component="span"
    sx={{
      display: 'inline-block',
      width: 26,
      height: 26,
      bgcolor: 'currentColor',
      mask: 'url(/juncerLogo.svg) center / contain no-repeat',
      WebkitMask: 'url(/juncerLogo.svg) center / contain no-repeat',
    }}
  />
);
